import ProductDescription from './ProductDescription'

const InfantMeatsProduct = {
  ...ProductDescription,
  category: '13',
  subCategory: '001',
  IsBroadband: true,
  PackageType: '',
  PacketSize: '2.5 ounces only',
  MultiPackageType: false,
  MultiPackageCount: '',
  Organic: false,
  NoAdditionalIngredients: false,
}

export default InfantMeatsProduct
